import React, { Component } from 'react';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Input from '../Input';
import Picker from '../Picker';
import Row from '../Row';
import Textarea from '../Textarea';
import Toggle from '../Toggle';
import Toast from '../Toast/Toast';
import Select from '../Select';
import CheckBox from '../Checkbox';
import { selectFndFormData } from '../../store/selectors/fndForm';
import { setFndFormData, clearFndFormData } from '../../store/actions/fndForm'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectUserProfileDetails } from '../../store/selectors/settings';
import { getUserProfileDetails } from '../../store/actions/settings'
import File from '../File';
import { upload } from '../../helpers/upLoadHelper';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Overlay from '../../components/Overlay';
import Marker from '../AnnotateImage/Marker';
// import { EditorState, convertToRaw, convertFromRaw,ContentState,convertFromHTML } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import { variables } from '../../Tenants';

import TextEditor from '../Editor/Editor';
import { onCheckDocument } from '../../helpers/CommonHelpers';

class NoteForm extends Component {
 
  
  constructor(props){
    super(props);

//     let editorState=(this.props.fndForm.hasOwnProperty('body') && this.props.fndForm.body.hasOwnProperty('blocks'))?EditorState.createWithContent(convertFromRaw(this.props.fndForm.body)):EditorState.createEmpty();
//   if(this.props.fndForm.id)
//   {
//     const blocksFromHTML = convertFromHTML(this.props.fndForm.body);
//     const cstate = ContentState.createFromBlockArray(
//     blocksFromHTML.contentBlocks,
//     blocksFromHTML.entityMap,
//  );
//       editorState = EditorState.createWithContent(cstate);
//   }
    this.state = {
      formData: {
        title: '',
        body: '',
      },
      saveButtonClicked:false,
      editorState: props.fndForm.body ? props.fndForm.body : "",
      buttonPressed: '',
      file:null,
      showOverlay:false,
      noteVisibleToHomeownerOccupantRealtor:false,
    }
  }

  componentDidMount(){
    const { user, setFndFormData }  = this.props;
    // if(user.roles[0].role.name === 'Home Owner'){
    //   setFndFormData({visibilityType:'Everyone'})
    // }
    setFndFormData({ visibilityType: 'Everyone' })
    setFndFormData({ noteVisibleToHomeownerOccupantRealtor: false })

  }

  componentDidUpdate () {
    const { validation, onClose, clearFndFormData, clearValidation } = this.props;
    if(validation.status === true) {
      if(validation.message === 'FaqDocNotes' && this.state.buttonPressed === 'SaveAndClose') {
        onClose();
        clearFndFormData();
        clearValidation();
      } else if(validation.message === 'FaqDocNotes' && this.state.buttonPressed === 'SaveAndAdd') {
        clearFndFormData();
        clearValidation();
        this.setState({ editorState: ""})
      }
    }
  }

  onEditorChange = (editorState) => {
    // const contentState = editorState.getCurrentContent();
    // this.props.setFndFormData({
    //   body:  draftToHtml(convertToRaw(contentState))
    // })
    this.setState({
      editorState,
    }, () => {
      this.props.setFndFormData({
        body: editorState
      })
    });
  }
  setFormData(e) {
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        ...e,
      },
    });
  }
  onSaveNote= async()=> {
    const { onClose, onSaveNote, clearFndFormData,setFndFormData,fndForm } = this.props;
    let formData = fndForm;
    let imageUrl=null
    if(fndForm.image && fndForm.image.length === 1){
      this.setState({saveButtonClicked:true})
      imageUrl =  await upload(fndForm.image[0])
      // setFndFormData({image:imageUrl})
      // formData = { ...fndForm, image:imageUrl}
      setTimeout(() => {
        this.setState({saveButtonClicked:false})        
      }, 3000);
    }    
    //Modified By: Anjali
    //Modified On: 10-10-2023
    //Jira-Id: https://bosframework.atlassian.net/browse/JUN-3876
    //Reason: When adding images to a note, it appears to be broken when trying to view the image.
   formData = { ...fndForm,noteVisibleToHomeownerOccupantRealtor:this.state.noteVisibleToHomeownerOccupantRealtor , image:imageUrl}
    onSaveNote(formData);
    // if(this.state.buttonPressed === 'SaveAndAdd') {
    //   clearFndFormData();
    // } else {
    //   onClose();
    // }
  }

  buttonDisabled(){
    const { fndForm,user } = this.props;
    if(fndForm.appointment){
      return !fndForm.title || !fndForm.body || !fndForm.appointment || !fndForm.appointment.date || !fndForm.appointment.time
    }else{
      if(user.roles[0].role.name === 'Home Owner'){
        return !fndForm.title || !fndForm.body
      }else{
        return !fndForm.title || !fndForm.body
      }
       
    }
  }

  handleRemainderToggle(value){
    let { settings,from,getUserProfileDetails,user } = this.props
    let noteNotification = this.props.settings.noteNotification;
 
    if(settings && settings.noteNotification){
    if(from === 'properties'){
      if(noteNotification.properties){
        this.props.setFndFormData({ appointment: !value })
      }else{
        toast.success('Please enable Properties Note Email Notification to add remainder',{autoClose:10000,position:'top-center'} )
      }
    }

    if(from === 'suites'){
      if(noteNotification.suites){
        this.props.setFndFormData({ appointment: !value })
      }else{
        toast.success(`Please enable ${variables.suiteName} Note Email Notification to add remainder`,{autoClose:10000,position:'top-center'})
      }
    }

    if(from === 'assets'){
      if(noteNotification.assets){
        this.props.setFndFormData({ appointment: !value })
      }else{
        toast.success('Please enable Assets Note Email Notification to add remainder',{autoClose:10000,position:'top-center'})
      }
    }

    if(from === 'serviceRequests'){
      if(noteNotification.serviceRequests){
        this.props.setFndFormData({ appointment: !value })
      }else{
        toast.success(`Please enable ${variables.serviceRequest} Note Email Notification to add remainder`,{autoClose:10000,position:'top-center'})
      }
    }

    if(from === 'inventoryItems'){
      if(noteNotification.inventoryItems){
        this.props.setFndFormData({ appointment: !value })
      }else{
        toast.success('Please enable InventoryItem Note Email Notification to add remainder',{autoClose:10000,position:'top-center'})
      }
    }

    if(from === 'contacts'){
      if(noteNotification.contacts){
        this.props.setFndFormData({ appointment: !value })
      }else{
        toast.success('Please enable Contacts Note Email Notification to add remainder',{autoClose:10000,position:'top-center'})
      }
    }

  }else{
      getUserProfileDetails(user.id)
      alert('Loading Please wait!')
  }

   
  }

  annotate(file){
    this.setState({showOverlay:true,file:file})

  }
  onSaveImagesAnotated(images){
    
    
  }

  render() {
    const { onClose, breadcrumb,fndForm, setFndFormData,user, loader } = this.props;

    let visibilityTypes = [ 'Everyone','Property Developer','Service Provider','Home Owner', 'Occupant']
    if(user.roles[0].role.name === "Home Owner"){
      visibilityTypes = [ 'Everyone','Property Developer','Service Provider']

    }else{
      visibilityTypes = [ 'Me','Everyone','Property Developers','Service Providers','Home Owners', 'Occupants']
    }
    if (fndForm.noteVisibleToHomeownerOccupantRealtor === true) {
      this.setState({noteVisibleToHomeownerOccupantRealtor:true})
    }
    return (
      <Form
        headline={(fndForm.id ? "Edit" : "Add") + " a Note"}
        onClose={() => onClose()}
        onSubmit={() => this.onSaveNote(fndForm, this.state.buttonPressed)}
        actions={
          <>
            {loader ? <Loader center={true} /> : null}
            {fndForm.id ? (
              <div />
            ) : (
              <Button
                color="semantic"
                size="small"
                label="Save and Add Another"
                onClick={() =>
                  this.setState({
                    buttonPressed: "SaveAndAdd",
                    // editorState:'',
                    title:''
                  })
                }
                disabled={this.buttonDisabled()}
                // disabled={!fndForm.title || !fndForm.body || fndForm.appointment  && (!fndForm.appointment.date)}
              />
            )}
            <Button
              color="teal"
              size="small"
              label="Save Note"
              onClick={() =>
                this.setState({
                  buttonPressed: "SaveAndClose",
                })
              }
              // disabled={!fndForm.title || !fndForm.body || fndForm.appointment && (!fndForm.appointment.date) }
              disabled={this.buttonDisabled() || this.state.saveButtonClicked}
            />
          </>
        }
        component={
          <>
            <Row mdCenter>
              <Col xs="12" md="6">
                {breadcrumb && (
                  <>
                    <Toast
                      message={
                        <>
                          You are adding a note to <strong>{breadcrumb}</strong>
                          .
                        </>
                      }
                    />
                    <br />
                    <br />
                  </>
                )}
                <Input
                  value={fndForm.title}
                  onChange={(e) => setFndFormData({ title: e.target.value })}
                  label="Subject"
                  required
                  placeholder="Subject"
                  block
                />
                <div className="input">
                  <div>
                  <CheckBox
                     value={this.state.noteVisibleToHomeownerOccupantRealtor}
                    checked={this.state.noteVisibleToHomeownerOccupantRealtor}
                    label="Display note for homeowners, occupants, realtors"
                    onChange={e => this.setState({noteVisibleToHomeownerOccupantRealtor: e.target.checked })}
              />
                  </div>
                </div>
                <div className="input">
                  <div className="input__require">
                    <label className="input__label">Description</label>
                    <div className="input__required" />
                  </div>
                  <div class style={{borderBottom: '0.1rem solid rgba(83, 83, 83, 0.25)'}} className="input__control">
                <TextEditor
                    editorState={this.state.editorState}
                    onEditorStateChange={this.onEditorChange}
                />
                </div>
                </div>
                <File
                  label="Image"
                  onSelect={(file) => {
                  onCheckDocument(file) &&  setFndFormData({ image: file });
                  }}
                  // onSelect={(file) => this.setState({showOverlay:true,file:file})}
                  files={
                    fndForm.image && fndForm.image.length === 1
                      ? fndForm.image
                      : []
                  }
                  image={
                    fndForm.image && fndForm.image.length > 1
                      ? fndForm.image
                      : null
                  }
                  errors={""}
                  from={'noteform'}
                  type="image"
                />
                <Toggle
                  label="Set a Reminder"
                  value={fndForm.appointment}
                  onToggle={(value) => this.handleRemainderToggle(value)}
                />
                {fndForm.appointment && (
                  <>
                    <Picker
                      showPopperArrow={false}
                      placeholderText="Date"
                      selected={
                        fndForm.appointment.date instanceof Date &&
                        !isNaN(fndForm.appointment.date)
                          ? fndForm.appointment.date
                          : null
                      }
                      onChange={(date) =>
                        setFndFormData({
                          ...fndForm,
                          appointment: { ...fndForm.appointment, date },
                        })
                      }
                    />
                    <Picker
                      // label="Include a Time (Optional)"
                      label="Include a Time"
                      placeholderText="Time"
                      showPopperArrow={false}
                      selected={
                        fndForm.appointment.time instanceof Date &&
                        !isNaN(fndForm.appointment.time)
                          ? fndForm.appointment.time
                          : null
                      }
                      onChange={(time) =>
                        setFndFormData({
                          ...fndForm,
                          appointment: { ...fndForm.appointment, time },
                        })
                      }
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      // disabledKeyboardNavigation
                      // readOnly={true}
                    />
                  </>
                )}

                {/* {user.roles[0].role.name === "Home Owner" ? null : (
                  <Select
                    value={
                      fndForm && fndForm.visibilityType
                        ? fndForm.visibilityType
                        : ""
                    }
                    onChange={(e) =>
                      setFndFormData({ visibilityType: e.target.value })
                    }
                    options={visibilityTypes.map((type, i) => ({
                      value: type,
                      label: type === "Everyone" ? type : type + " only",
                    }))}
                    label="Visibility Type"
                    placeholder="Choose the role type"
                    block
                  />
                )} */}
              </Col>
            </Row>
            <Overlay
              showOverlay={this.state.showOverlay}
              content={
                <Marker
                  onClose={() => this.setState({ showOverlay: false })}
                  img={this.state.file}
                  onSaveImagesAnotated={(images) =>
                    this.onSaveImagesAnotated(images)
                  }
                />
              }
            />
          </>
        }
      />
    );
  }
}

const mapStateToProps = state => ({
  user:selectAuthenticatedUser(state),
  fndForm: selectFndFormData(state),
  settings:selectUserProfileDetails(state),
  loader: selectFormLoader(state),
  validation: selectValidation(state),
})


const mapDispatchToProps = dispatch => bindActionCreators({
  setFndFormData,
  clearFndFormData,
  getUserProfileDetails,
  clearValidation: clearValidation
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NoteForm);

